var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_body"},[_c('MainHeader',{attrs:{"theme":"","showSearch":"true","showMenu":"true","menuId":"0","showBanner":"true"}}),_c('IndustryList'),_c('LastPublished'),_c('HotDownload'),_c('MainFooter'),_c('UserLogin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }